module.exports = __webpack_public_path__ + "img/dienteAzul.c93d7d8b.svg";